import { useEffect } from 'react';

import style from './NotFound.module.scss';

import { store } from '@store';
import { translate } from '@chaika/i18n/helper';
import notFound from './not_found.svg?url';

export function NotFound() {
    useEffect(() => {
        store.app.withoutHeader = true;

        return () => {
            store.app.withoutHeader = false;
        };
    }, []);

    return (
        <div className={style.root}>
            <span className={style.code}>
                <img
                    alt={'Page not found'}
                    src={notFound}
                />
            </span>
            <span className={style.message}>{translate('pageNotFound')} :(</span>
        </div>
    );
}
